import { getCurrentThemeConfig, hasFeature, getCurrentTheme } from '@/config/themeConfig'

/**
 * 主題 Mixin
 * 在組件中引入後，可以直接使用：
 * - this.currentTheme - 當前主題名稱
 * - this.themeConfig - 當前主題的所有配置
 * - this.hasFeature(name) - 檢查是否有某功能
 * - this.isTheme(name) - 檢查是否為指定主題
 */
export default {
  computed: {
    /**
     * 當前主題名稱
     * @returns {string} 'theme_gold', 'theme_blue', etc.
     */
    currentTheme() {
      return getCurrentTheme()
    },

    /**
     * 當前主題的所有功能配置
     * @returns {Object} 功能配置對象
     */
    themeConfig() {
      return getCurrentThemeConfig()
    }
  },

  methods: {
    /**
     * 檢查當前主題是否啟用某功能
     * @param {string} featureName - 功能名稱
     * @returns {boolean} 是否啟用
     */
    hasFeature(featureName) {
      return hasFeature(featureName)
    },
    // 檢查是否為指定主題
    isTheme(themeName) {
      return this.currentTheme === themeName
    }
  }
}
